import {
  GET_PLAN_DETAILS_SUCCESS,
  UPDATE_CANCELLATION_NOTES_SUCCESS,
  UPDATE_CANCELLATION_META_SUCCESS,
} from '../actions';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PLAN_DETAILS_SUCCESS:
      return payload.PlanCancellation;
    case UPDATE_CANCELLATION_NOTES_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_CANCELLATION_META_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
